export const phoneRegExp =/^[6-9]\d{9}$/;
export const emailRegExp =/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}([;,|][\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,})*$/
